import {
  Activity,
  Beaker,
  Boxes,
  Brain,
  Calculator,
  ClipboardCheck,
  Download,
  Flower2,
  Gift,
  GitCompare,
  GlassWater,
  GraduationCap,
  Library,
  ListChecks,
  Martini,
  Presentation,
  ShieldCheck,
  Sparkles,
  Star,
  Timer,
  Users,
  Wine,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Professional Visual Training Volumes', icon: Library, featured: true },
  { label: 'Complete 6-IN-1 Training System', icon: Boxes, featured: true },
  { label: 'Ready-to-Teach Lessons', icon: Presentation, featured: true },
  { label: 'Bar Tools & Glassware', icon: GlassWater },
  { label: 'Responsible Alcohol Service', icon: ShieldCheck },
  { label: 'Essential Bartending Techniques', icon: Timer },
  { label: 'Classic Cocktail Specs', icon: Martini },
  { label: 'Advanced Mixology Techniques', icon: Beaker },
  { label: 'Spirits & Liqueurs', icon: Wine },
  { label: 'Sensory Analysis & Flavor Profiles', icon: Brain },
  { label: 'Garnishing & Presentation', icon: Flower2 },
  { label: 'Menu Design & Costing', icon: Calculator },
  { label: 'Bar Operations & Inventory', icon: ClipboardCheck },
  { label: 'Practice Builds & Service Drills', icon: Users },
  { label: '❌/✅ Comparisons', icon: GitCompare },
  { label: 'Assessment Rubrics', icon: ClipboardCheck },
  { label: 'Drills & Quick Checks', icon: ListChecks },
  { label: 'Easy to Advanced Variants', icon: Star },
  { label: 'Instructor Resources', icon: GraduationCap },
  { label: '5 Exclusive Bonuses', icon: Gift, featured: true },
  { label: 'Teaching Cues', icon: Sparkles },
  { label: 'Lesson Plans', icon: Activity },
  { label: 'Immediate Digital Access', icon: Download },
]
